module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.c4bab49e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-arrow-down.svg
// module id = 104
// module chunks = 3